// extracted by mini-css-extract-plugin
export default {"cls1":"tvfJPMpahCGn2ZDlgkg9","cls2":"HMeim8Vf8pDabHHyvNiw tvfJPMpahCGn2ZDlgkg9"};